// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__1OmBj","title":"style_title__2tUZk","form":"style_form__-a8tn","input":"style_input__255qx"};